<section class="usersDropdown" [ngStyle]="{ width: dropdownWidth }">
  @if (!hideExtraOptions) {
    <pp-search-box
      ppPlaceholder="Filter users"
      (ppAction)="setSearchBox($event)"
      class="usersSearchBox dropdown__searchBar"
      [ppFocusOnInit]="true"
      ppSize="wide"
    ></pp-search-box>
  }

  @if (showButtons) {
    <div class="usersDropdown__removeAll">
      <button class="usersDropdown__removeAllButton" (click)="removeAllUsers()">
        {{ 'remove_all' | ppTranslate }}
      </button>
    </div>
  }

  <ul
    #list
    (ppOnRendered)="updateScrolledToBottom()"
    class="dropdownWrapper users__list"
    [ngStyle]="{ 'max-height.px': maxHeight }"
    (scroll)="handleScroll($event)"
    >
    @for (userId of selectableUsers; track userId) {
      @if (showButtons || unselectedUserIds.includes(userId)) {
        <li
          (click)="selectUserFromRow(userId, $event)"
          [class.users__item--clickable]="!showButtons"
          class="users__item"
          >
          <div class="users__itemInner">
            @if (users[userId].avatarPublicUrl) {
              <img
                ppTooltip
                ppImage
                class="user__avatar"
                [src]="users[userId].avatarPublicUrl"
                [ppMobileTooltip]="true"
                [ppTitle]="users[userId].userName"
                />
            }
            @if (!users[userId].avatarPublicUrl) {
              <img
                ppTooltip
                class="user__avatar"
                [src]="EIconPath.PLACEHOLDER_USER"
                [ppMobileTooltip]="true"
                [ppTitle]="users[userId].userName"
                />
            }
            <ul class="users__select-details">
              <li class="users__select-username">
                {{ users[userId].userName }}
              </li>
              <li class="users__select-user-email">
                {{ users[userId].email }}
              </li>
            </ul>
          </div>
          @if (showButtons) {
            <pp-users-dropdown-button
              [ppSelected]="!unselectedUserIds.includes(userId)"
              (ppSelect)="selectUser(userId)"
            ></pp-users-dropdown-button>
          }
        </li>
      }
    }
  </ul>

  @if (!selectableUsers || selectableUsers.length === 0) {
    <div class="warning__message">
      {{ 'no_additional_to_display' | ppTranslate: { type: type } }}
    </div>
  }

  @if (!hideExtraOptions) {
    <footer class="usersDropdown__footer">
      @if (!scrolledToBottom) {
        <div class="optionsDropdown__shadow">&nbsp;</div>
      }
      <div class="optionsDropdown__shadow-footer-buttons">
        <pp-button ppStyle="secondary" (ppAction)="clearUsers()">
          {{ 'clear_all' | ppTranslate }}
        </pp-button>
        <pp-button ppStyle="primary" (ppAction)="hideDropdown()">
          {{ 'done' | ppTranslate }}
        </pp-button>
      </div>
    </footer>
  }
</section>
